import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTC: CultureInfo = {
  name: 'en-TC',
  displayName: 'English (Turks & Caicos Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TC',
  parent: CultureInfoEn
};
